import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { PagingQuery } from 'tea-component';
import { useHistory, useIntl, getLocale } from 'umi';
import SortBy, {
  SortByItemType,
} from '@/pages/intelligence/components/TableComponents/components/SortBy';
import FirstRow from '@/pages/intelligence/components/TableComponents/components/FirstRow';
import { TopchartTableProps } from '@/pages/intelligence/pages/_config/topchartsInterface';

import CloumsCenter from '@/pages/intelligence/components/TableComponents/components/CloumsCenter';
import {
  TableCheckboxHeader,
  TableCheckboxRender,
} from '@/pages/intelligence/components/TableComponents/components/TableCheckbox';
import { getCountryFlag } from '@/pages/home/_config/countries';
import { CommonMetricColumn } from '../columns';
import { useMobileOptionList } from '@/pages/intelligence/pages/TopCharts/_hooks/useMobileOptionList';
import TopchartTable from '@/pages/intelligence/components/TableComponents/TopchartTable';
import { getDetailGameOverviewPath } from '@/pages/intelligence/utils/topchartsUtils';
import { DetailsCloums } from '@/pages/intelligence/pages/TopCharts/_config/TableCloums/CommonCloums';
import { getGameRankDetails } from '@intelligence/utils/tableUtils';
import { getTagFilterColumns } from '@intelligence/v3/utils/sensorTowerTagColumns';

export default function NewReleaseMobileTable(props: TopchartTableProps & {
  filterValue?: IRecord<any>;
  gameDetailsLoading?: boolean;
  gameDetailsMapping?: IRecord<IRecord>;
  onTagClick?: (type: string, tag: string) => void;
}) {
  const {
    loading,
    records = [],
    tableTotal,
    pageSortAttr,
    onTableSortChage,
    onTablePagingChange,
    tableSelection,
    tableSelectionAll,
    onTableCheckGame,
    entityType,
    filterValue,
    gameDetailsLoading = true,
    gameDetailsMapping = {},
    onTagClick,
  } = props;

  const { potentialNewReleaseMetrics } = useMobileOptionList();
  const { formatMessage } = useIntl();
  const locale = getLocale();
  const { tablePageIndex, tablePageSize, currentSortValue, currentSortMetric } =
    pageSortAttr || {};
  const history = useHistory();
  // const [expandedKeys, setExpandedKeys] = useState<any>([]);
  const defaultPageSize = 100;
  const [pageIndex, setPageIndex] = useState(tablePageIndex || 1);
  const [pageSize, setPageSize] = useState(tablePageSize || defaultPageSize);
  const [selectList, setSelectList] = useState(tableSelection);
  // const [subTableWidth, setSubTableWidth] = useState<string | number>('auto');

  // const { regionOptions } = useMarketFilterApi({});
  // useEffect(() => {
  //   setExpandedKeys([]);
  // }, [loading]);

  useEffect(() => {
    setSelectList(tableSelection);
  }, [tableSelection]);

  useEffect(() => {
    setPageIndex(tablePageIndex);
    setPageSize(tablePageSize);
  }, [tablePageIndex, tablePageSize]);

  const onPagingChange = (e: PagingQuery) => {
    setPageIndex(e.pageIndex || 1);
    setPageSize(e.pageSize || defaultPageSize);
    onTablePagingChange(e);
  };

  const onSortChage = (e: SortByItemType) => {
    onTableSortChage(e);
  };

  const onClickGame = (gameId: string) => {
    history.push(getDetailGameOverviewPath(gameId, 'mobile'));
  };
  const getMetricCloums = () => {
    const metricCloums: any[] = [];
    // DAU Revenue Download 每个数据源赋值一遍
    potentialNewReleaseMetrics.forEach((t) => {
      metricCloums.push(
        CommonMetricColumn({
          ...t,
          currentSortValue,
          currentSortKey: `${currentSortMetric}`,
          onSortChage,
          entityType,
          showCompareBubble: true,
        }),
      );
    });
    return metricCloums;
  };

  // const observeTableSize = (width) => {
  //   setSubTableWidth(width);
  // };

  return (
    <>
      {/* sub-table-fixed 子表格固定的类名 组件库修改 全局通用 */}
      <TopchartTable
        // className="dbi-mobileGames-table sub-table-fixed dbi-mobile-table"
        // observeTableSize={observeTableSize}
        // bordered="all"
        recordKey={'app_id'}
        loading={loading}
        records={records}
        tableTotal={tableTotal}
        pageIndex={pageIndex}
        pageSize={pageSize}
        onPagingChange={onPagingChange}
        columns={[
          // {
          //   key: 'expand',
          //   width: 36,
          //   fixed: 'left',
          // },
          {
            key: 'select',
            width: 36,
            fixed: 'left',
            header: () => (
              <TableCheckboxHeader
                selectList={selectList}
                tableSelectionAll={tableSelectionAll}
                disabled={loading || records?.length === 0}
                onChange={(list, stats) => {
                  onTableCheckGame(list, stats);
                  setSelectList(list);
                }}
              />
            ),
            render: (cvm: any) => (
              <TableCheckboxRender
                selectList={selectList}
                cvm={{ ...(cvm || {}), gameId: cvm?.app_id }}
                disabled={getGameRankDetails(cvm?.rank).isDisabled}
                onChange={(list, status) => {
                  setSelectList(list);
                  onTableCheckGame(list, status);
                }}
              />
            ),
          },
          {
            key: 'app_id',
            header: (
              <div className="dbi-firstRow-flex">
                <div className="dbi-text-id">#</div>
                <div>{formatMessage({ id: 'dbi_top_gametitle' })}</div>
              </div>
            ),
            width: 330,
            fixed: 'left',
            render: (cvm: any) => (
              <FirstRow
                id={getGameRankDetails(cvm?.rank)?.rankText}
                cvm={{
                  img: cvm?.cover,
                  gametitle: cvm?.name,
                  countryIcon: getCountryFlag(cvm?.publisher_addr),
                  text: cvm?.publisher,
                }}
                rihgtClickToJumpHref={getDetailGameOverviewPath(cvm?.app_id, 'mobile')}
                onClick={() => {
                  onClickGame(cvm?.app_id);
                }}
              />
            ),
          },
          // CountryColumn(),
          // PHeatColumn({
          //   currentSortKey: currentSortMetric,
          //   currentSortValue: currentSortValue,
          //   onSortChage,
          // }),
          // {
          //   key: 'plan',
          //   align: 'center',
          //   width: 200,
          //   header: (
          //     <CloumsCenter width={200} align="left">
          //       <div className="header-other">
          //         {formatMessage({ id: 'dbi_top_plan' })}
          //       </div>
          //     </CloumsCenter>
          //   ),
          //   render: (cvm: any) => {
          //     const planName = planOptionFilterOptions?.find(item => item.value === cvm?.plan)?.text || ''
          //     return (
          //       <CloumsCenter width={200} align="left">
          //         {planName}
          //       </CloumsCenter>
          //     );
          //   },
          // },
          ...getMetricCloums(),
          {
            key: 'release_time',
            align: 'center',
            width: 170,
            header: (
              <CloumsCenter width={170} align="left">
                <SortBy
                  align="left"
                  title={formatMessage({ id: 'dbi_release_date' })}
                  defaultKey={currentSortMetric}
                  defaultValue={currentSortValue}
                  list={[
                    {
                      key: `release_time_0`,
                      sortMetric: 'release_time',
                      text: formatMessage({ id: 'dbi_release_date' }),
                      title: formatMessage({ id: 'dbi_release_date' }),
                    },
                  ]}
                  onChange={onSortChage}
                />
              </CloumsCenter>
            ),
            render: (cvm: any) => (
              <CloumsCenter width={170} align="left">
                {cvm?.release_time ? moment(cvm.release_time).format('YYYY-MM-DD') : '-'}
              </CloumsCenter>
            ),
          },
          ...getTagFilterColumns({
            filterValue,
            gameDetailsLoading,
            gameDetailsMapping,
            locale,
            formatMessage,
            onTagClick,
          }),
          DetailsCloums({
            onClickGame: (cvm: any) => {
              onClickGame(cvm?.app_id);
            },
            formatMessage,
          }),
        ]}
      // expandableAddon={{
      //   targetColumnKey: 'expand',
      //   expandedKeys,
      //   onExpandedKeysChange: (keys, { event, operateRecord }) => {
      //     setExpandedId(keys[0] ? keys[keys?.length - 1] : '');
      //     event.stopPropagation();
      //     setExpandedKeys(keys);
      //   },
      //   render(record) {
      //     return (
      //       <div
      //         style={{
      //           width: subTableWidth || 'auto',
      //         }}
      //       >
      //         <MarketTable
      //           data={record}
      //           countryList={record.markets ? record.markets.split(',') : []}
      //           gameId={expandedId}
      //         />
      //       </div>
      //     );
      //   },
      // }}
      />
    </>
  );
}
